<template>
  <div class="patient-table">
    <div class="patient-table__body-mobile">
      <button
        class="patient-table__body-mobile__row"
        type="button"
        v-for="({
          id, fullName, medicalCardNumber, index,
        }) in patientList"
        v-bind:key="id"
        v-on:click="onEditPatient(id)">
        <dt>№</dt>
        <dd>{{ index + 1 }}</dd>
        <dt>ФИО</dt>
        <dd>{{ fullName }}</dd>
        <dt>№ карты</dt>
        <dd>{{ medicalCardNumber }}</dd>
      </button>
    </div>
    <table class="patient-table__table">
      <patient-table-head
        v-bind:columns="visibleColumns"
        v-bind:has-delete="hasDelete"
      >
        <th slot="full_name">
          <input-sort
            v-model="sortByFullName"
            v-on:input="sortPatientListByFullName"
            name="fullname"
          >
            <div
              class="patient-table__cell sort"
              v-bind:class="{ selected: sortByFullName ? 'selected' : '' }">
              ФИО</div>
          </input-sort>
        </th>
        <th slot="medical_card_number" class="card-number">
          <input-sort

            v-model="sortByCard"
            v-on:input="sortPatientListByCard"
            name="card"
          >
            <div
              class="patient-table__cell sort"
              v-bind:class="{ selected: sortByCard ? 'selected' : '' }">
              № карты</div>
          </input-sort>
        </th>
        <th slot="last_visit">
          <input-sort
            v-model="sortByLastVisit"
            v-on:input="sortPatientListByLastVisit"
            desc-first
            name="lastvisit"
          >
            <div
              class="patient-table__cell sort"
              v-bind:class="{ selected: sortByLastVisit ? 'selected' : '' }">
              Последний визит</div>
          </input-sort>
        </th>
        <th slot="near_appointment">
          <input-sort
            slot="near_appointment"
            v-model="sortByNearAppointment"
            v-on:input="sortPatientListByNearAppointment"
            name="nearappointment"
          >
            <div
              class="patient-table__cell sort"
              v-bind:class="{ selected: sortByNearAppointment ? 'selected' : '' }">
              Ближайшая запись</div>
          </input-sort>
        </th>
        <div v-if="false" class="patient-table__cell">ИЭМК</div>
        <template v-slot:settings>
          <popover-menu>
            <template v-slot:trigger="{ listenerObject }">
              <th class="patient-table__cell" colspan="2">
                <button
                  v-on="listenerObject"
                  class="patient-table__icon-settings"
                  type="button"
                />
              </th>
            </template>
            <form-table-settings
              v-bind:columns="columnSettings"
              v-on:change="onChangeColumnSettings"
            />
          </popover-menu>
        </template>
      </patient-table-head>
      <tbody
        v-if="!this.isPatientListEmpty && !this.isAwaitRequest"
        class="patient-table__body"
      >
        <patient-table-row
          v-for="patient in patientList"
          v-bind:key="patient.id"
          v-bind:row="patient"
          v-bind:columns="visibleColumns"
        >
          <td
            slot="number"
            data-label="№"
            class="patient-table__cell number">
            {{ patient.index + 1 }}
          </td>
          <td
            slot="full_name"
            class="patient-table__cell fio"
            data-label="ФИО"
          >
            <div class="patient-table__cell__fio">
              <button
                class="patient-table__fio-button"
                title="Открыть"
                type="button"
                v-on:click="onEditPatient(patient.id)"
              >
                {{ patient.fullName }}
              </button>
              <button
                class="patient-table__icon-copy"
                title="Копировать"
                type="button"
                v-on:click.stop="onCopyPatient(patient.id)" />
            </div>
          </td>
          <td
            data-label="Статус ИЭМК"
            class="patient-table__cell"
            v-bind:class="patient.iemkStatus.getId()"
            v-bind:title="patient.iemkStatus.getText()"
            v-if="false">{{ patient.iemkStatus.getTitle() }}</td>
          <td
            slot="cda_completeness"
            class="patient-table__cell cda-completeness"
            data-label="Заполненность для СЭМД"
            v-bind:class="cdaCompleteness"
            v-if="hasViewCdaCompleteness">{{ patient.cdaCompleteness }}</td>
          <template slot="actions">
            <td
              data-label="Редактировать"
              class="patient-table__cell"
            >
              <button
                class="patient-table__icon-edit"
                type="button"
                title="Редактировать пациента"
                v-on:click="onEditPatient(patient.id)" />
            </td>
            <td
              data-label="Выгрузить"
              class="patient-table__cell"
              v-if="hasDownload">
              <button
                class="patient-table__icon-download"
                type="button"
                title="Скачать архив"
                v-bind:disabled="isDownloadDisabled"
                v-on:click="onDownloadPatient(patient.id)"
              />
            </td>
            <td
              data-label="Удалить"
              class="patient-table__cell"
              v-if="hasDelete">
              <button
                class="patient-table__icon-delete"
                type="button"
                title="Удалить пациента"
                v-on:click="onDeletePatient(patient.id)" />
            </td>
          </template>
        </patient-table-row>
      </tbody>
    </table>
    <div
      v-if="this.isPatientListEmpty && !this.isAwaitRequest"
      class="patient-table__message"
    >
      Ничего не найдено
    </div>
  </div>
</template>
<script>
import FormTableSettings from '@/components/FormTableSettings.vue';
import InputSort from '@/components/InputSort.vue';
import { getDate } from '@/utils/timeFormat';
import PopoverMenu from '@/components/PopoverMenu.vue';

const HEADERS = {
  number: '',
  full_name: 'ФИО',
};

const COLUMN_KEYS = {
  advance: 'advance',
  amount_payments: 'amountPayments',
  debt: 'debt',
  last_visit: 'lastVisit',
  medical_card_number: 'medicalCardNumber',
  near_appointment: 'nearAppointmentDate',
  phone: 'phone',
  treatment_plan_count: 'planCount',
};

/**
 * @description Компонент заголовка таблицы пациентов.
 */
const PatientTableHead = {
  functional: true,
  name: 'PatientTableHead',
  props: {
    columns: { required: true, type: Array },
    hasDelete: { required: true, type: Boolean },
  },
  render(createElement, { props, scopedSlots }) {
    const makeCell = (label, key) => createElement(
      'th',
      { staticClass: `patient-table__cell ${key}`, key: `head-${key}` },
      label,
    );
    const row = createElement(
      'tr',
      [
        ...props.columns.map((column) => {
          if (scopedSlots[column.id]) {
            return scopedSlots[column.id]();
          }
          let label = '';
          if (column.id in HEADERS) {
            label = HEADERS[column.id];
          } else {
            label = column.name;
          }
          return makeCell(label, column.id);
        }),
        makeCell('', 'edit'),
        scopedSlots.settings(),
      ],
    );
    return createElement(
      'thead',
      { staticClass: 'patient-table__head' },
      [row],
    );
  },
};

/**
 * @description Компонент строки таблицы пациентов.
 */
const PatientTableRow = {
  functional: true,
  name: 'PatientTableRow',
  props: {
    columns: { required: true, type: Array },
    row: { required: true, type: Object },
  },
  render(createElement, { props, scopedSlots }) {
    const makeCell = (label, text) => createElement(
      'td',
      { staticClass: 'patient-table__cell', attrs: { 'data-label': label } },
      text,
    );
    return createElement(
      'tr',
      {
        staticClass: 'patient-table__row',
      },
      [
        ...props.columns.map((column) => {
          if (scopedSlots[column.id]) {
            return scopedSlots[column.id]();
          }
          const rowKey = COLUMN_KEYS[column.id];
          return makeCell(column.name, props.row[rowKey] || '');
        }),
        scopedSlots.actions(),
      ],
    );
  },
};

/**
 * @description Таблица пациентов.
 * @type {any}
 */
export default {
  created() {
    this.sortByFullName = this.sort.type === 'fullname' ? this.sort.order : '';
    this.sortByCard = this.sort.type === 'card' ? this.sort.order : '';
    this.sortByLastVisit = this.sort.type === 'lastvisit' ? this.sort.order : '';
    this.sortByNearAppointment = this.sort.type === 'nearappointment' ? this.sort.order : '';
  },
  data() {
    return {
      sortByFullName: '',
      sortByCard: '',
      sortByLastVisit: '',
      sortByNearAppointment: '',
    };
  },
  components: {
    FormTableSettings,
    InputSort,
    PatientTableHead,
    PatientTableRow,
    PopoverMenu,
  },
  computed: {
    /**
     * @description Является ли список пациентов пустым.
     * @returns {boolean}
     */
    isPatientListEmpty() {
      return !Object.keys(this.patientList).length;
    },
    /**
     * @description Видимые столбцы.
     * @returns {any[]}
     */
    visibleColumns() {
      return this.columns.filter((candidate) => candidate.is_visible);
    },
  },
  methods: {
    /**
     * Сортировать список пациентов по полному имени
     */
    sortPatientListByFullName() {
      this.sortByCard = '';
      this.sortByLastVisit = '';
      this.sortByNearAppointment = '';
      this.$emit('sort-patient-list', {
        type: 'fullname',
        order: this.sortByFullName,
      });
    },
    /**
     * Сортировать список пациентов по номеру карты
     */
    sortPatientListByCard() {
      this.sortByFullName = '';
      this.sortByLastVisit = '';
      this.sortByNearAppointment = '';
      this.$emit('sort-patient-list', {
        type: 'card',
        order: this.sortByCard,
      });
    },
    /**
     * Сортировать список пациентов по последнему визиту
     */
    sortPatientListByLastVisit() {
      this.sortByFullName = '';
      this.sortByCard = '';
      this.sortByNearAppointment = '';
      this.$emit('sort-patient-list', {
        type: 'lastvisit',
        order: this.sortByLastVisit,
      });
    },
    /**
     * Сортировать список пациентов по ближайшей записи
     */
    sortPatientListByNearAppointment() {
      this.sortByFullName = '';
      this.sortByCard = '';
      this.sortByLastVisit = '';
      this.$emit('sort-patient-list', {
        type: 'nearappointment',
        order: this.sortByNearAppointment,
      });
    },
    /**
     * @description Обработать копирование кабинета.
     * @param {number} id Идентификатор пациента.
     * @returns {void}
     */
    onCopyPatient(id) {
      this.$emit('copy-patient', id);
    },
    /**
     * @description Обработать изменение настроек.
     */
    onChangeColumnSettings(columns) {
      this.$emit('change-column-settings', columns);
    },
    /**
     * @description Обработать удаление пациента.
     * @param {number} id Идентификатор пациента.
     * @returns {void}
     */
    onDeletePatient(id) {
      this.$emit('delete-patient', id);
    },
    /**
     * @description Обработать выгрузку пациента.
     * @param {number} id
     * @returns {void}
     */
    onDownloadPatient(id) {
      this.$emit('download-patient', id);
    },
    /**
     * @description Обработать редактирование пациента.
     * @param {number} id Идентификатор пациента.
     * @returns {void}
     */
    onEditPatient(id) {
      this.$emit('edit-patient', id);
    },
    /**
     * @description Получить отформатированное строковое представление даты.
     * @param {string} date Дата.
     * @returns {string}
     */
    getDate(date) {
      if (date === 'нет') {
        return date;
      }
      return getDate(new Date(date));
    },
  },
  props: {
    /**
     * @description Настройки столбцов.
     */
    columnSettings: { required: true, type: Array },
    /**
     * @description Cтолбцы.
     */
    columns: { required: true, type: Array },
    /**
     * @description Может смотреть заполненность для СЭМД.
     */
    hasViewCdaCompleteness: {
      required: true,
      type: Boolean,
    },
    /**
     * @description Может копировать пациентов.
     * @type {boolean}
     */
    hasCopy: { required: true, type: Boolean },
    /**
     * @description Может удалять пациентов.
     * @type {boolean}
     */
    hasDelete: { required: true, type: Boolean },
    /**
     * @description Может выгружать пациентов.
     * @type {boolean}
     */
    hasDownload: { required: true, type: Boolean },
    isDownloadDisabled: { required: true, type: Boolean },
    /**
     * @description Список пациентов.
     * @type {any[]}
     */
    patientList: { type: Array, required: true },
    /**
     * @description Ожидание завершения запроса.
     * @type {boolean}
     */
    isAwaitRequest: { type: Boolean, required: true },
    /**
     * @description Тип сортировки
     * @type {Object}
     */
    sort: { type: Object, default: () => ({ type: '', order: '' }) },
  },
};
</script>
<style lang="scss">

.patient-table {
  counter-reset: counterEmployees;
  margin: 25px 0 0 0;
  overflow-x: auto;
  &__body-mobile {
    display: none;
    flex-direction: column;
    gap: 10px;
    &__row {
      display: grid;
      font-size: 12px;
      grid-template-columns: auto 1fr;
      justify-items: flex-end;
      align-items: center;
      row-gap: 5px;
      padding: 5px;
      &:nth-child(odd) {
        background-color: var(--fill-color);
      }
      & > dt {
        justify-self: flex-start;
      }
      & > dd {
        text-align: right;
      }
    }
  }
  &__table {
    width: 100%;
    border-collapse: collapse;
    th {
      &:first-of-type {
        min-width: 40px;
      }
      &:nth-of-type(2) {
        min-width: 130px;
      }
      &.card-number,
      &.amount_payments,
      &.advance,
      &.debt {
        min-width: 100px;
      }
    }
  }
  &__head,
  &__row {
    font-size: 14px;
    line-height: 17px;
  }
  &__head {
    font-weight: 700;
    border-bottom: 2px solid #0489e0;
  }
  &__row {
    border-bottom: 1px solid #eaeff3;
    padding: 0;
    &:hover {
      background: #eaeff3;
    }
  }
  &__exclamation-mark-alert {
    right: 15px;
    font-size: 24px;
    font-weight: 400;
    color: #f21e1e;
  }
  &__cell {
    padding: 12px 8px;
    text-align: left;
    transition: color var(--animate-duration);
    &__fio {
      display: inline-flex;
      align-items: center;
      gap: 10px;
      text-align: left;
      button:first-child {
        text-align: left;
      }
      &:hover {
        cursor: pointer;
        color: var(--action-color);
      }
    }
    &.sort {
      text-align: left;
      cursor: pointer;
      display: flex;
      align-items: center;
      &:after {
        content: '';
        background-image: url("@/assets/img/checked/checked-grey.svg");
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        width: 10px;
        height: 10px;
        margin: 0 0 0 5px;
      }
      &:hover {
        text-decoration: none;
      }
      &.selected {
        color: var(--action-color);
      }
    }
    .theme--light.v-icon:focus:after {
      opacity: 0;
    }
    &.fio {
      padding: 0;
    }
    &.success,
    &.fail,
    &.none {
      display: flex;
      align-items: center;
    }
    &.success:before,
    &.fail:before,
    &.none:before {
      content: '';
      height: 20px;
      margin-right: 10px;
      width: 20px;
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }
    &.success {
      background: #E4FFEC !important;
      &:before {
        background-image: url("@/assets/img/checked/all-checked-green.svg");
      }
    }
    &.fail {
      background: #FFECEC;
      &:before {
        background-image: url("@/assets/img/exit-red.svg");
      }
    }
    &.none:before {
      height: 6px;
      width: 6px;
      background: #ABB1A3;
      border-radius: 50%;
      margin: 0 10px 0 6px;
    }
  }
  &__cell.cda-completeness {
    font-size: 0px;
    &::after {
      font-size: 1rem;
    }
    &.empty::after {
      content: '-';
    }
    &.full::after {
      content: '+';
    }
    &.unknown::after {
      content: '?';
    }
  }
  &__message {
    text-align: center;
    padding-top: 40px;
    font-size: 24px;
  }
  &__icon {
    &-edit {
      display: block;
      background-image: url("@/assets/img/pen-grey.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 14px;
      height: 14px;
      padding: 0;
      margin: 0;
      cursor: pointer;
      &:hover {
        background-image: url("@/assets/img/pen-blue.svg");
      }
    }
    &-settings {
      display: block;
      background-image: url("@/assets/img/settings-blue.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 18px;
      height: 18px;
      padding: 0;
      margin: 0;
      float: right;
      cursor: pointer;
    }
    &-delete {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 16px;
      min-height: 16px;
      width: 20px;
      height: 20px;
      background-image: url("@/assets/img/exit-grey.svg");
      background-repeat: no-repeat;
      background-position: 50% 50%;
      background-size: 12px 12px;
      cursor: pointer;
      &:hover {
        background-image: url("@/assets/img/exit-blue.svg");
      }
    }
    &-download {
      display: block;
      background-image: url("@/assets/img/download-file.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 20px;
      height: 20px;
      padding: 0;
      margin: 0;
      cursor: pointer;
    }
    &-copy {
      display: block;
      background-image: url("@/assets/img/copy-grey.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 14px;
      min-width: 14px;
      height: 14px;
      min-height: 14px;
      padding: 0;
      margin: 0;
      cursor: pointer;
      &:hover {
        background-image: url("@/assets/img/copy-blue.svg");
      }
    }
  }
}
@media screen and (max-width: 1400px) {
  .patient-table {
    &__head,
    &__row {
      font-size: 12px;
      line-height: 17px;
    }
  }
}
@media screen and (max-width: 1250px) {
  .patient-table {
    &__head {
      display: none;
    }
    &__row {
      display: grid;
      grid-template-columns: 1fr;
      grid-gap: 10px;
      margin: 0 0 20px 0;
      font-size: 14px;
    }
    &__fio-button {
      margin-left: auto;
    }
    &__cell {
      display: flex;
      justify-content: space-between;
      text-align: right;
      padding: 0;
      &.fio {
        text-align: right;
      }
    }
    &__cell:before {
      content: attr(data-label);
      font-weight: 700;
      margin-right: 20px;
      font-size: 14px;
    }
  }
}

@media screen and (max-width: 960px) {
  .patient-table {
    &__row,
    &__cell:before {
      font-size: 12px;
    }
  }
}
@media screen and (max-width: 480px) {
  .patient-table__body {
    display: none;
    &-mobile {
      display: flex;
    }
  }
}
</style>
